import { WppSpinner } from '@platform-ui-kit/components-library-react'

import styles from 'layout/loadingPage/LoadingPage.module.scss'

export const LoadingPage = () => (
  <div className={styles.container}>
    <WppSpinner data-testid="loading-page-spinner" size="l" />
  </div>
)
